"use client";

import { Alert, Box, Snackbar, ThemeProvider } from "@mui/material";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import SharedVideoCall from "./common/components/virtualVisit/SharedVideoCall";
import { theme } from "./common/utils/theme";
import { hideSnackbar } from "./redux/slices/auth.slice";
import type { RootState } from "./redux/store/store";
import { NavbarOptions } from "./routes/layouts/widget/constants";
import AppRouter from "./routes/routes";
import RedirectHandler from "./routes/RedirectHandler";
import { setPatientName } from "./redux/slices/ehr/patientCharting.slice";

function App() {
  const dispatch = useDispatch();
  const { selectedModule } = useSelector((store: RootState) => store?.module);
  const { snackbar } = useSelector((store: RootState) => store?.auth);
  const menuOptions = NavbarOptions[selectedModule]?.title || "";
  const patientName = useSelector(
    (state: RootState) => state?.patientCharting?.patientName,
  );
  const [modifiedHelment, setModifiedHelment] = useState(null);

  const pathname = window.location.pathname;

  useEffect(() => {
    const isPatientPath = pathname.includes("/ehr/patients");
    if (menuOptions === "EHR" && patientName && isPatientPath) {
      let modifiedString = `${menuOptions}- ${patientName}`;
      setModifiedHelment(modifiedString);
    } else {
      setModifiedHelment(null);
      dispatch(setPatientName(null));
    }
  }, [menuOptions, patientName, pathname]);

  const handleCloseSnackbar = () => {
    dispatch(hideSnackbar());
  };

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "auto",
      }}
      bgcolor={theme.palette.grey.A700}
    >
      <Helmet>
        <title>{modifiedHelment || menuOptions}</title>
      </Helmet>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <RedirectHandler />
          <AppRouter />
          <SharedVideoCall />
        </BrowserRouter>
        <Snackbar
          open={snackbar?.isOpen}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity={snackbar?.severity || "info"}
            sx={{ width: "100%" }}
          >
            {snackbar?.message}
          </Alert>
        </Snackbar>
      </ThemeProvider>
    </Box>
  );
}

export default App;
